import { useState, useEffect } from 'react';
import { API_BASE_URL } from './config';

export function useSidebar() {
  const [showMobileSidebar, setShowMobileSidebar] = useState(false);
  const [hideDesktop, setHideDesktop] = useState(false);

  const toggleSidebar = () => {
    if (window.innerWidth <= 991) {
      setShowMobileSidebar((s) => !s);
    } else {
      setHideDesktop((s) => !s);
    }
  };

  useEffect(() => {
    const onResize = () => {
      if (window.innerWidth > 991) {
        setShowMobileSidebar(false);
      }
    };

    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  useEffect(() => {
    const overlay = document.getElementById('sidebar-overlay');
    if (overlay) {
      overlay.style.display = showMobileSidebar ? 'block' : 'none';
    }
    const sidebar = document.getElementById('sidebar');
    if (sidebar) {
      if (showMobileSidebar) sidebar.classList.add('show-mobile');
      else sidebar.classList.remove('show-mobile');
      if (hideDesktop) sidebar.classList.add('hide-desktop');
      else sidebar.classList.remove('hide-desktop');
    }
    const content = document.getElementById('content');
    if (content) {
      if (hideDesktop) content.classList.add('full-width');
      else content.classList.remove('full-width');
    }
  }, [showMobileSidebar, hideDesktop]);

  return { toggleSidebar, setShowMobileSidebar };
}

export function useProductivitySummary(mode) {
  const [summary, setSummary] = useState({
    productivityPercent: 0,
    neutralPercent: 0,
  });
  const [summaryError, setSummaryError] = useState(null);

  useEffect(() => {
    const controller = new AbortController();

    const loadSummary = async () => {
      try {
        setSummaryError(null);
        const endpoint = mode === 'daily' ? 'today' : 'weekly';

        const res = await fetch(`${API_BASE_URL}/api/Productivity/${endpoint}`, {
          signal: controller.signal,
        });

        if (!res.ok) {
          throw new Error(`Status ${res.status}`);
        }

        const data = await res.json();
        setSummary({
          productivityPercent: data.productivityPercent ?? 0,
          neutralPercent: data.neutralPercent ?? 0,
        });
      } catch (err) {
        if (err.name !== 'AbortError') {
          console.error('Error loading productivity summary:', err);
          setSummaryError(err.message || 'Failed to load summary');
        }
      }
    };

    loadSummary();

    return () => controller.abort();
  }, [mode]);

  return { summary, summaryError };
}